<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-thai');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u0e3a',
                    '\u0e01 \u0e02 \u0e03 \u0e04 \u0e05 \u0e06 \u0e07',
                    '\u0e08 \u0e09 \u0e0a \u0e0b \u0e0c \u0e0d',
                    '\u0e0e \u0e0f \u0e10 \u0e11 \u0e12 \u0e13',
                    '\u0e14 \u0e15 \u0e16 \u0e17 \u0e18 \u0e19',
                    '\u0e1a \u0e1b \u0e1c \u0e1e \u0e20 \u0e21',
                    '\u0e1d \u0e1f',
                    '',
                    '\u0e22 \u0e23 \u0e25 \u0e27 \u0e28 \u0e29 \u0e2a \u0e2b \u0e2c \u0e2d \u0e2e',
                    '',
                    '\u0e30 \u0e31 \u0e32 \u0e34 \u0e35 \u0e36 \u0e37 \u0e38 \u0e39',
                    '\u0e24 \u0e26 \u0e45 \u0e40 \u0e41 \u0e42 \u0e33 \u0e44 \u0e43',
                    '',
                    '\u0e48 \u0e49 \u0e4a \u0e4b &nbsp; \u0e47 \u0e4c \u0e4d \u0e4e',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
